module.exports = __webpack_public_path__ + "img/info3_b.6ca0ade7.svg";